module.exports = __webpack_public_path__ + "static/media/logo-telefonica.39801ebd.svg";